/** Page numbers to show around the current page (inclusive). */
export function computePageWindow(
  page: number,
  totalPages: number,
  radius = 2
): number[] {
  const pages: number[] = [];
  const start = Math.max(1, page - radius);
  const end = Math.min(totalPages, page + radius);
  for (let p = start; p <= end; p += 1) pages.push(p);
  return pages;
}
